import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=f3a9ca5c&scoped=true"
import script from "./Minimal.vue?vue&type=script&lang=js"
export * from "./Minimal.vue?vue&type=script&lang=js"
import style0 from "./Minimal.vue?vue&type=style&index=0&id=f3a9ca5c&prod&lang=scss&scoped=true"
import style1 from "./Minimal.vue?vue&type=style&index=1&id=f3a9ca5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a9ca5c",
  null
  
)

export default component.exports